export const POSTHOG_EVENTS = {
  userLoggedIn: "user_logged_in",
  somethingWentWrongToastShown: "something_went_wrong_toast_shown",
  scaSetupInitializeFailed: "sca_setup_initialize_failed",
  scaSetupCreatePasskeyFailed: "sca_setup_create_passkey_failed",
  scaSetupFinalizeFailed: "sca_setup_finalize_failed",
  scaSetupFailed: "sca_setup_failed",
  scaSetupSucceeded: "sca_setup_succeeded",
  scaSigningInitiated: "sca_signing_initiated",
  scaSigningSucceeded: "sca_signing_succeeded",
  scaSigningCancelled: "sca_signing_cancelled",
  scaSigningFailed: "sca_signing_failed",
  scaLoginFailed: "sca_login_failed",
  scaLoginSucceeded: "sca_login_succeeded",
  scaAuthenticateFailed: "sca_authenticate_failed",
  scaAuthenticateSucceeded: "sca_authenticate_succeeded",
  hankoRequestFailed: "hanko_request_failed",
  approvePayoutFailed: "approve_payout_failed",
  approvePayoutSucceeded: "approve_payout_succeeded",
  approvePayoutsBatchFailed: "approve_payouts_batch_failed",
  approvePayoutsBatchSucceeded: "approve_payouts_batch_succeeded",
  approveRefundFailed: "approve_refund_failed",
  approveRefundSucceeded: "approve_refund_succeeded",
  approveRefundsBatchFailed: "approve_refunds_batch_failed",
  approveRefundsBatchSucceeded: "approve_refunds_batch_succeeded",
} as const;

export const POSTHOG_FLOWS = {
  scaSetup: "sca_setup",
  scaLogin: "sca_login",
  scaAuthenticate: "sca_authenticate",
  transactionSigning: "transaction_signing",
  approvePayout: "approve_payout",
  approvePayoutsBatch: "approve_payouts_batch",
  approveRefund: "approve_refund",
  approveRefundsBatch: "approve_refunds_batch",
} as const;
